import { Payout } from '@models/Payout'
import { limit, orderBy, where } from 'firebase/firestore'
import { payoutsCollection } from './framework/ClientCollections'

/** Retrieves the latest `n` payouts for a farm, sorted by `arrivalDate` descending */
export async function loadPayoutsByFarm(farmId: string, limitN = 10): Promise<Payout[]> {
  return payoutsCollection.fetchAll(where('farm.id', '==', farmId), limit(limitN), orderBy('arrivalDate.utc', 'desc'))
}
